import Entity from './entity'
export default class moisture_equipment extends Entity<number>{
    ftId:number;
    wId:number;
    fId:number;
    status:number = 1;
}